// src/redux/reducers/cbdReducer.js

import { combineReducers } from "redux";

import cbdSlice from "../slice/cbd-slice/cbd-slice";


const cbdReducer = combineReducers({
  cbd: cbdSlice,
});

export default cbdReducer;
